import "../../Styling/Portfolio/PortfolioList.css";
import { motion } from "framer-motion";
import { portfolioData } from "../../Data/ShowcaseData";
import NavBar from "../Home/NavBar";
import useDocumentTitle from "../../Utilities/useDocumentTitle";
import { Helmet } from "react-helmet";

const variant = {
  visible: { scale: 1 },
  hidden: { scale: 0 },
};

const PortfolioList = () => {
  useDocumentTitle("42nd - Privacy");

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>42nd - Portfolio</title>
      </Helmet>
      <NavBar />

      <main className="portfolio-main">
        <div className="portfolio-wrapper">
          <h1 className="portfolio-title">Portfolio</h1>
          {/* Grid */}
          <section className="more-work-section-wrapper">
            {/* Grid */}
            <div className="portfolio-grid">
              {Object.values(portfolioData).map((item, idx) => (
                <motion.a
                  key={idx}
                  className="link"
                  href={`/portfolio/details/${item.id}`}
                  whileHover={{ scale: 1.025 }}
                >
                  <motion.div
                    className="image-wrapper"
                    variants={variant}
                    initial="hidden"
                    whileInView="visible"
                  >
                    <div className="text-header-wrapper">
                      {item.caseStudy ? (
                        <p className="tag-text" style={{ color: "white" }}>
                          Case Study
                        </p>
                      ) : (
                        <p className="tag-text" style={{ color: "white" }}>
                          Real Product
                        </p>
                      )}
                    </div>
                    <img className="image" alt={item.title} src={item.imgUrl} />
                  </motion.div>
                </motion.a>
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default PortfolioList;
